import { useTranslation } from '@hooks';
import { NewButton } from '@components/ui';

const AddToCartButton = ({ onButtonClick, selectedSize, comming }) => {
    const { t } = useTranslation();

    const showPickSizeText = (!selectedSize || selectedSize === '') && !comming;
    const buttonText = showPickSizeText
        ? t('pickSize')
        : comming
        ? 'COMING SOON'
        : t('addToBasket');

    return (
        <NewButton
            size="xlarge"
            type="primary"
            content={buttonText}
            data-testid="add-to-cart-button"
            disabled={comming}
            aria-label="Add to cart button"
            handleClick={onButtonClick}
        />
    );
};

export default AddToCartButton;
